import { render, staticRenderFns } from "./ShiftWork.vue?vue&type=template&id=97b974fe&scoped=true"
import script from "./ShiftWork.vue?vue&type=script&lang=js"
export * from "./ShiftWork.vue?vue&type=script&lang=js"
import style0 from "./ShiftWork.vue?vue&type=style&index=0&id=97b974fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b974fe",
  null
  
)

export default component.exports